<template>
  <div></div>
</template>

<script>
import Highcharts from 'highcharts'
import 'highcharts/highcharts-more'
export default {
  data() {
    return {
      instance: null,
      debounce: {
        updateOptions: _.debounce(this.updateOptions, 100),
        updateType: _.debounce(this.updateType, 100)
      }
    }
  },
  mounted() {
    this.debounce.updateType()
    this.debounce.updateOptions()
  },
  unmounted() {
    try {
      this.instance?.destroy()
    } catch {
      //
    }
    this.instance = null
  },
  computed: {
    options() {
      return Object.assign({}, this.config?.options || {}, {
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        accessibility: {
          enabled: false
        }
      })
    },
    type() {
      return this.config?.type
    }
  },
  methods: {
    updateOptions() {
      if (Object.keys(this.options).length == 0) return
      let options = Object.assign(
        {
          title: {
            text: ''
          },
          credits: {
            enabled: false
          },
          accessibility: {
            enabled: false
          }
        },
        this.options || {}
      )
      if (this.instance) {
        this.instance.update(options, true, true)
      } else {
        Highcharts.chart(this.$el, options, (chart) => (this.instance = chart))
      }
    },
    updateType() {
      if (!(this.config?.type instanceof Function)) return
      this.config.type(Highcharts)
    }
  },
  watch: {
    options() {
      this.debounce.updateOptions()
    },
    type() {
      this.debounce.updateType()
    }
  },
  props: {
    config: Object
  }
}
</script>
